export const handleChangeColor = (index, type) => {
  const numIndex = Number(index);

  const normalizedType =
    typeof type === "string" ? type.toLowerCase() : "other";

  if (normalizedType === "syrup") {
    switch (numIndex) {
      case 1:
        return "bg-success-600/20";
      case 2.5:
        return "bg-success-600/20";
      case 5:
        return "bg-success-600/20";
      case 7.5:
        return "bg-success-600/20";
      case 10:
        return "bg-success-600/20";
      case 15:
        return "bg-success-600/20";
      case 20:
        return "bg-success-600/20";
      case 30:
        return "bg-success-600/20";
      default:
        return "bg-success-default";
    }
  } else {
    // Default case for other product types
    switch (numIndex) {
      case 0.5:
        return "bg-success-600/20";      
      case 1:
        return "bg-success-600/20";
      case 1.5:
        return "bg-success-600/20";        
      case 2:
        return "bg-success-600/20";
      case 2.5:
        return "bg-success-600/20";        
      case 3:
        return "bg-success-600/20";
      case 3.5:
        return "bg-success-600/20";        
      case 4:
        return "bg-success-600/20";
      case 4.5:
        return "bg-success-600/20";        
      case 5:
        return "bg-success-600/20";
      case 6:
        return "bg-success-600/20";
      case 7:
        return "bg-success-600/20";
      case 8:
        return "bg-success-600/20";
      case 9:
        return "bg-success-600/20";
      case 10:
        return "bg-success-600/20";
      case 11:
        return "bg-success-600/20";
      case 12:
        return "bg-success-600/20";
      case 13:
        return "bg-success-600/20";
      case 14:
        return "bg-success-600/20";
      case 15:
        return "bg-success-600/20";
      case 16:
        return "bg-success-600/20";
      case 17:
        return "bg-success-600/20";
      case 18:
        return "bg-success-600/20";
      case 19:
        return "bg-success-600/20";
      case 20:
        return "bg-success-600/20";
      case 30:
        return "bg-success-600/20";
      default:
        return "bg-success-default";
    }
  }
};

export const formatDateString = (dateObj) => {
  if (!dateObj) return "";
  const d = new Date(dateObj);
  if (isNaN(d.getTime())) return String(dateObj).split("T")[0];
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getTodayString = () => {
  return formatDateString(new Date());
};

export const getProductRowTags = (product, catalogProducts = [], nrxDrugNames = []) => {
  const combined = [];
  const seen = new Set();

  const addTag = (t, src) => {
    if (!t) return;
    const name = typeof t === "string" ? t : t?.name || t?.tagName || t?.tag;
    if (!name || typeof name !== "string") return;
    const norm = name.trim().toUpperCase();
    if (!norm) return;
    if (!seen.has(norm)) {
      seen.add(norm);
      combined.push({
        id: t?.id || norm,
        name: name.trim(),
        color: t?.color || "#3B82F6",
        category: t?.category,
        source: src || t?.source || "product",
      });
    }
  };

  // 1. Direct tags array on product (from backend enricher or payload)
  (product?.tags || []).forEach((t) => addTag(t, t?.source || "product"));
  (product?.productTags || []).forEach((t) => addTag(t, "product"));
  (product?.drugTags || []).forEach((t) => addTag(t, "drug"));
  (product?.product?.tags || []).forEach((t) => addTag(t, "product"));

  // 2. Fallback check from catalog products if tags array is empty
  if (combined.length === 0 && Array.isArray(catalogProducts)) {
    const pIID = product?.IID || product?.productId;
    const pName = product?.productName;
    const found = catalogProducts.find((cp) => {
      const item = cp?.product || cp;
      return (
        (pIID && String(item?.IID || item?.id) === String(pIID)) ||
        (pName &&
          String(item?.productName).trim().toLowerCase() ===
            String(pName).trim().toLowerCase())
      );
    });
    if (found) {
      const item = found?.product || found;
      (item?.tags || []).forEach((t) => addTag(t, "product"));
      (item?.drugTags || []).forEach((t) => addTag(t, "drug"));

      // Check if item's drugs match nrxDrugNames
      const drugs = item?.drugs || product?.drugs || [];
      if (Array.isArray(drugs) && Array.isArray(nrxDrugNames)) {
        const hasNRx = drugs.some((d) => {
          const dName = (
            typeof d === "string" ? d : d?.drugName || d?.name
          )
            ?.toString()
            ?.trim()
            ?.toUpperCase();
          return (
            dName &&
            nrxDrugNames.some((nrx) => {
              const nNorm = nrx?.toString()?.trim()?.toUpperCase();
              return (
                nNorm &&
                (nNorm === dName ||
                  dName.includes(nNorm) ||
                  nNorm.includes(dName))
              );
            })
          );
        });
        if (hasNRx) {
          addTag({ id: "nrx", name: "NRX/H1", color: "#EF4444" }, "drug");
        }
      }
    }
  }

  return combined;
};

